import React from "react";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";
// core imports
import { SFStack } from "../../../components/grid";
import {
  SFCheckCircleIcon,
  SFWarningIcon
} from "../../../components/icons";
import getStyled from "../../../hooks/getStyled";
import SFTypography from "../../../components/typography";

const { styled } = getStyled();

const StyledOffset = styled("div")(({ theme }) => ({
  width: 18,
}));

const RowValuesValidationLabel = ({ percentage }) => {
  const { t } = useTranslation();
  let label, icon;
  //values validation here
  if (percentage === 0) {
    label = (
      <Trans i18nKey={"fileUploadWizard.fileMapping.allValuesAreValidLabel"} />
    );
    icon = <SFCheckCircleIcon size="small" />;
  } else {
    label = (
      <Trans
        i18nKey={"fileUploadWizard.fileMapping.validRowsPercentageLabel"}
        values={{ percentage: Math.round(percentage) }}
      />
    );
    icon = <SFWarningIcon size="small" />;
  }

  return (
    <>
      <SFStack direction="row" alignItems="center" spacing={2}>
        {icon}
        <SFTypography variant="body1bold">{label}</SFTypography>
      </SFStack>
      {percentage !== 0 && (
        <SFStack direction="row" alignItems="center" spacing={2}>
          <StyledOffset></StyledOffset>
          <SFTypography variant="body2bold">
            {t("fileUploadWizard.fileMapping.correctMissingRowValuesLabel")}
          </SFTypography>
        </SFStack>
      )}
    </>
  );
};

RowValuesValidationLabel.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default RowValuesValidationLabel;
